import BellIcon from '@tradera/blueprint/theme/icons2/bell.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import {
    closeCategoryDropdownMenu,
    closeProfileMenu,
    closeWishListSideSheet,
    closeNotificationsSideSheet,
    openNotificationsSideSheet
} from 'tradera/state/ui/reducer';
import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';
import { classNames } from 'tradera/utils/class-names';
import { NotificationsBadge } from 'tradera/components/site-header/notifications-badge';

export const NotificationsLink = () => {
    const dispatch = useAppDispatch();

    const { isOpen } = useAppSelector(
        (state) => state.ui.notificationsSideSheet
    );

    const handleOnClick = () => {
        if (isOpen) {
            dispatch(closeNotificationsSideSheet());
        } else {
            dispatch(closeWishListSideSheet());
            dispatch(closeCategoryDropdownMenu());
            dispatch(closeProfileMenu());

            dispatch(openNotificationsSideSheet());
        }
    };

    return (
        <Button
            className={classNames('slim-header__button', isOpen && 'active')}
            rel="nofollow"
            data-ga-category="Top navigation"
            data-ga-action="Notifications menu"
            data-ga-label="Link - Notifications from NavBar"
            data-nav-wishlist
            onClick={handleOnClick}
            theme="text">
            <NotificationsBadge />
            <BellIcon className="icon icon-md" />
        </Button>
    );
};
